module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptertitle"
  }, [_c('a', {
    attrs: {
      "id": "chapter01"
    }
  }), _vm._v("Chapter 1")]), _vm._v(" "), _c('h1', {
    staticClass: "chaptertitle"
  }, [_vm._v("Advanced Strategies Overview")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("WHEN WE FIRST SET OUT TO LEARN SOMETHING NEW, it’s very helpful to have simple guidelines to follow: charts and graphs, checklists and straightforward tables of do’s and don’ts. Whenever we begin to explore a new topic we want samples to copy and models to emulate: recipes that tell us exactly what to do.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But recipes and prescribed formulas have their limitations. Think of the cook who can only produce a meal by following a recipe. What if some of the essential ingredients are missing? What if other ingredients are available instead? What if more people turn up than expected?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("While the novice cook knows how to follow recipes, the master chef knows how to work with whatever’s available. He or she has an intimate knowledge of a wide range of ingredients and how they react to each other in different combinations and at various temperatures. The expert chef has what the amateur cook does not: a deep understanding of the principles of cooking and intimate knowledge about a wide range of ingredients and how to use them in different situations.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In facilitation, as in cooking, things don’t always go as planned! Factors that were originally thought to be unrelated can unexpectedly emerge as central issues. The subject being discussed may suddenly reveal itself to be far more complex than previously thought. Group members may begin to exhibit counterproductive behaviors without apparent cause. The process that you designed so carefully can suddenly unravel!")]), _vm._v(" "), _c('div', {
    staticClass: "feature2"
  }, [_c('div', {
    staticClass: "feature2_text"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Even the simplest facilitation can unexpectedly become complex!")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Since any discussion has the potential to become complex, it’s essential that all facilitators move beyond the basics as soon as they possibly can. This means increasing your knowledge of the core principles of process leadership and knowing which strategies will work when the going gets tough.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This book aims to support you in your personal journey to the advanced level by offering you techniques and strategies to deal with a wide range of facilitation dilemmas. These include:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("the inherently powerless nature of facilitation")]), _vm._v(" "), _c('li', [_vm._v("the difficulty of gaining and keeping the role")]), _vm._v(" "), _c('li', [_vm._v("the challenge of working with upper management")]), _vm._v(" "), _c('li', [_vm._v("the overstressed and often resistant outlook of participants")]), _vm._v(" "), _c('li', [_vm._v("the difficulties inherent in making complex decisions")]), _vm._v(" "), _c('li', [_vm._v("the politics and hidden agendas present in many situations")]), _vm._v(" "), _c('li', [_vm._v("the dysfunctional behaviors that limit group effectiveness")]), _vm._v(" "), _c('li', [_vm._v("the challenge of providing structure to groups who may resist it")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In today’s fast-paced workplace, every conversation needs to be carefully designed and expertly executed in order to achieve maximum results. To do this you need to possess advanced strategies!")]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "sec01"
    }
  }), _vm._v("Your Personal Philosophy of Facilitation")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("It’s logical to assume that the keys to becoming more skillful are to practice often, gather more tools and hone one’s session design skills. While these activities are clearly important, the first step toward reaching the advanced level is actually the development of a personal philosophy of facilitation.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Having a clear set of principles and practices firmly in place will act like a foundation. It will ground you and make you more resilient in challenging situations. A clear personal philosophy will guide your interactions with others and provide you with a rationale when considering which elements to include in any design.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If you operate without a clear personal philosophy, you’ll be lacking the organizing principle that will help you see patterns in your work. In this void you’ll be randomly cobbling together tools and techniques in the hope that they create patterns of interaction that make sense. This need for clarity is further accentuated by the fact that there’s still considerable confusion in the minds of many people about facilitation. This further accentuates why you must have a clear understanding of the purpose of your craft.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To help you develop a personal philosophy, consider adopting the following unassailable principles:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Facilitation is grounded in a sincere respect for all group members regardless of their age, rank or cultural group.")]), _vm._v(" "), _c('li', [_vm._v("Facilitation is a transparent endeavor characterized by honesty and positive intent.")]), _vm._v(" "), _c('li', [_vm._v("Facilitators believe that everyone possesses innate wisdom that can be harnessed and channeled for the good of the whole.")]), _vm._v(" "), _c('li', [_vm._v("All facilitation activities aim to foster cooperation and commitment.")]), _vm._v(" "), _c('li', [_vm._v("Facilitators advocate empowerment and participation so that groups buy in and own the outcomes of their deliberations.")]), _vm._v(" "), _c('li', [_vm._v("Facilitators value the synergistic power of collective thought and strive to help groups arrive at collaborative decisions that represent a win for all parties.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Most important, facilitators never use the process role in order to seek personal power or control. The main goal of all facilitation activities is to enhance the effectiveness of others, whether that’s the personal effectiveness of an individual who is being coached, the ability of a team to reach its goals, or the overall wellness of an organization and its culture.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The quest for a philosophy of facilitation is a personal journey that each of us needs to embark upon for ourselves. In addition to reading the works of leading thinkers in this field, you can begin by asking yourself some simple questions, such as:")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Why do I want to be a facilitator? What are my motives?”")])]), _vm._v(" "), _c('p', {
    staticClass: "extractpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“What do I bring to the people I facilitate?”")])]), _vm._v(" "), _c('p', {
    staticClass: "extractpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“What’s unique about my work as a facilitator?”")])]), _vm._v(" "), _c('p', {
    staticClass: "extractpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“What elements must always be present in my work?”")])]), _vm._v(" "), _c('p', {
    staticClass: "extractpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“What actions or activities will I always exclude from my work?”")])]), _vm._v(" "), _c('p', {
    staticClass: "extractpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“What are the most important outcomes of my work?”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Once you’ve given this some thought, formulate a personal philosophy statement that you can share with others in order to clarify the principles that inform your work. This statement may evolve over time as your work matures and will always provide you with an anchor in times of doubt in the case of conflicting priorities.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("My personal philosophy of facilitation:")])]), _vm._v(" "), _c('div', {
    staticClass: "graphic"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0004-01.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "sec02"
    }
  }), _vm._v("The Three Levels of Competence")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("Increasing personal proficiency in any skill typically involves moving through a series of levels. Review the following description of facilitation skill levels and then complete the self-assessment that begins on page 7 to identify both your current competencies and the skills you most need to acquire.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("Level I")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("New facilitators almost always start out leading the regularly scheduled meetings held within their own department or project team. These are meetings where they’re familiar with the content under discussion and will be able to ask effective questions due to their knowledge of the issues being explored.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In these meetings the group leader is typically present, as are the facilitator’s peers. The facilitator may be notified in advance to lead the meeting or, as is often the case, be pressed into action without much notice when the need for facilitation materializes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The focus at Level I is:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("understanding the core principles, models and concepts of facilitation")]), _vm._v(" "), _c('li', [_vm._v("being able to manage a group discussion using core skills such as remaining neutral, asking questions, paraphrasing and summarizing")]), _vm._v(" "), _c('li', [_vm._v("having awareness of the key components of an effective meeting design")]), _vm._v(" "), _c('li', [_vm._v("knowing how to foster participation and encourage effective behaviors")]), _vm._v(" "), _c('li', [_vm._v("knowing when to use various decision-making tools")]), _vm._v(" "), _c('li', [_vm._v("making clear and accurate summaries and notes")]), _vm._v(" "), _c('li', [_vm._v("knowing various techniques for taking the pulse of the group in order to get things back on track")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("Level II")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("Once a facilitator has gained experience managing regular staff meetings, he or she may be asked to lead special purpose meetings for their peers or even for groups who are outside their work unit.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This transition can take place for a number of reasons. It can occur naturally simply because all groups have a periodic need for special purpose meetings such as problem-solving sessions, planning meetings, or team-building workshops.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This shift can also happen when a facilitator is sought out for assistance by those outside his or her immediate work group because they’ve gained a reputation for being effective. Regardless of the reason for the shift, leading more complex, special-purpose conversations requires an additional level of skill. This is especially true if the participants are unknown to the facilitator.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The focus at Level II is:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("knowing how to gather information, assess data and determine participant needs")]), _vm._v(" "), _c('li', [_vm._v("being aware of a wide repertoire of tools and techniques")]), _vm._v(" "), _c('li', [_vm._v("being able to design complex conversations")]), _vm._v(" "), _c('li', [_vm._v("being skilled at helping groups make difficult decisions and overcome decision blocks")]), _vm._v(" "), _c('li', [_vm._v("being able to manage a variety of complicated group dynamics without losing neutrality or personal composure")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("Level III")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("A facilitator is required to possess skills at the third and final level of mastery any time they’re approached to design and lead processes that involve either a planned intervention to resolve a dispute, an initiative aimed at enhancing organizational effectiveness, or a planned change effort. Whether the assignment is internal or external to their usual work group, when a facilitator takes on a facilitation assignment that’s part of one of these activities, they’re functioning as an Organization Development consultant.")]), _vm._v(" "), _c('div', {
    staticClass: "feature2"
  }, [_c('div', {
    staticClass: "feature2_text"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Organization Development is a planned effort to increase an organization’s effectiveness and health through planned interventions in the organization’s processes using behavioral-science knowledge. O.D. interventions can be conducted on an organization-wide basis, focus on a single department or activity, apply at the small-group level, or be used on an individual basis.")])]), _vm._v(" "), _c('div', {
    staticClass: "featuresource"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("(Beckhard, 1969)")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Note that the facilitator is now said to be acting as a consultant because they’re acting to help or support a client through the application of their specialized knowledge in a situation where they lack managerial control. In the case of Organization Development consulting, that special knowledge is the application of process tools and techniques that are used to guide stakeholders through specific steps of the planned activity.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The focus at Level III is:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("possessing a personal philosophy of facilitation")]), _vm._v(" "), _c('li', [_vm._v("knowing about the core principles and practices of Organization Development")]), _vm._v(" "), _c('li', [_vm._v("being aware of the stages in the facilitation process")]), _vm._v(" "), _c('li', [_vm._v("being skilled at designing a wide range of data-gathering techniques")]), _vm._v(" "), _c('li', [_vm._v("knowing the key process models used to make interventions")]), _vm._v(" "), _c('li', [_vm._v("being able to design and facilitate complex, multi-stage interventions")])]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "sec03"
    }
  }), _vm._v("Where Are You Now? — Self-Assessment")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("Begin your journey to facilitation mastery by reviewing the descriptions and competencies that follow. Identify both the skills that you currently possess and those areas in need of further development, then create your personal learning goals. The descriptions and competencies are arranged in three levels:")]), _vm._v(" "), _c('div', {
    staticClass: "feature3"
  }, [_c('div', {
    staticClass: "feature3_text"
  }, [_vm._v("Level I – consists of the core skills required to lead routine discussions and manage meetings effectively")]), _vm._v(" "), _c('div', {
    staticClass: "feature3_text"
  }, [_vm._v("Level II – consists of the ability to design complex decision processes and manage difficult situations")]), _vm._v(" "), _c('div', {
    staticClass: "feature3_text"
  }, [_vm._v("Level III – involves designing and leading activities that are part of a planned change effort")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("Level I - Basic Competencies Self-Assessment")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("New facilitators almost always start out leading the regularly scheduled meetings held within their own department or project team. These are meetings where they’re familiar with the content under discussion and will be able to ask effective questions due to their knowledge of the issues being explored.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In these meetings the group leader is typically present, as are the facilitator’s peers. The facilitator may be notified in advance to lead the meeting or, as is often the case, be pressed into action without much notice if the need for facilitation materializes.")]), _vm._v(" "), _c('div', {
    staticClass: "feature3"
  }, [_c('div', {
    staticClass: "feature3_text"
  }, [_vm._v("1 = totally disagree 2 = disagree 3 = not sure 4 = agree 5 = totally agree")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "98%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tabularentry",
    staticStyle: {
      "width": "88%"
    }
  }, [_vm._v("1. I understand the concepts, values and beliefs underpinning facilitation.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("2. I’m aware of what to do at the start, middle and end of a facilitation")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("3. I’m skilled at active listening, paraphrasing, questioning and summarizing key points.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("4. I’m able to manage time and maintain a good pace.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("5. I know techniques for encouraging active participation and generating ideas.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("6. I know how to create and then use group norms to encourage effective behaviors.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("7. I can make clear notes that accurately reflect what members have said.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("8. I’m familiar with the core process tools used to structure participative group discussions.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("9. I understand the difference between various decision-making tools and know when to use each one.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("10. I understand how to help a group achieve consensus and gain closure.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("11. I’m skilled at offering constructive feedback to groups and am comfortable accepting personal feedback.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("12. I know the key components of an effective meeting design and can create a detailed agenda.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("13. I know how to ask good probing questions that challenge assumptions in a nonthreatening way.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("14. I know when and how to conduct periodic process checks.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("15. I know how to use a variety of exit surveys to improve meeting effectiveness.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])])])]), _vm._v(" "), _c('div', {
    staticClass: "feature3"
  }, [_c('div', {
    staticClass: "feature3_text"
  }, [_vm._v("Level I skills I currently possess:")]), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "feature3_text"
  }, [_vm._v("Level I skills that I would like to develop further:")]), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("Level II – Intermediate Competencies Self-Assessment")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("Once a facilitator has gained experience managing regular staff meetings, they may be asked to lead special-purpose meetings for their peers or even for groups who are outside their work unit.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This transition can take place for a number of reasons. It can occur naturally simply because all groups have a periodic need for special-purpose meetings such as problem-solving sessions, planning meetings, or team-building workshops.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This shift can also happen when a facilitator is sought out for assistance by those outside their immediate work group if they’ve gained a reputation for being effective. Regardless of the reason for the shift, leading more complex, special-purpose conversations requires an additional level of skill. This is especially true if the participants are unknown to the facilitator.")]), _vm._v(" "), _c('div', {
    staticClass: "feature3"
  }, [_c('div', {
    staticClass: "feature3_text"
  }, [_vm._v("1 = totally disagree 2 = disagree 3 = not sure 4 = agree 5 = totally agree")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "98%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("16. I know how to use surveys and conduct interviews to assess group needs and interests.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("17. I can design meetings for a variety of purposes and can adjust my designs in mid-stream if necessary.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("18. I know strategies to create a safe environment and gain buy-in from reluctant participants.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("19. I can deal with resistance nondefensively, even when it’s aimed at me personally.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("20. I know the signs of ‘group think’ and can structure discussions to overcome it.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("21. I’m skilled at asking complex probing questions that help members uncover underlying issues and information.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("22. I can recognize the signs of group tension or conflict and do not hesitate to offer that insight to groups.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("23. I’m able to appropriately and assertively intervene in order to redirect ineffective behavior.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("24. I’m able to articulate both sides of an issue, then offer a process to reframe the conversation.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("25. I’m able to hear and then consolidate ideas from a mass of information and create coherent summaries.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("26. I can recognize when decision processes are polarized and know how to restructure them so they’re collaborative.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("27. I possess tools to help groups out of decision deadlocks.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("28. I understand the team development process and know how to implement a variety of team-building activities.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("29. I’m sensitive to interests, needs and concerns of individuals from different cultural backgrounds and from various levels and functions in the organization.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("30. I’m sufficiently versed in process responses that I never lose my neutrality even during difficult conversations.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])])])]), _vm._v(" "), _c('div', {
    staticClass: "feature3"
  }, [_c('div', {
    staticClass: "feature3_text"
  }, [_vm._v("Level II skills I currently possess:")]), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "feature3_text"
  }, [_vm._v("Level II skills that I would like to develop further:")]), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("Level III – Advanced Competencies Self-Assessment")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("A facilitator is required to possess skills at the third and final level of mastery any time they’re approached to design and lead processes that involve either a planned intervention to resolve a dispute, an initiative aimed at enhancing organizational effectiveness or a planned change effort. Whether the assignment is internal or external to their usual work group, when a facilitator takes on such a facilitation assignment, they’re functioning as an Organization Development consultant.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Note that the facilitator is now said to be acting as a consultant because they’re acting to help or support a client through the application of their specialized knowledge in a situation where they lack managerial control. In the case of Organization Development consulting, that special knowledge is the application of process tools and techniques that are used to engage stakeholders in every step of the planned activity.")]), _vm._v(" "), _c('div', {
    staticClass: "feature3"
  }, [_c('div', {
    staticClass: "feature3_text"
  }, [_vm._v("1 = totally disagree 2 = disagree 3 = not sure 4 = agree 5 = totally agree")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "98%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("31. I have a personal philosophy of facilitation that guides my work.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("32. I’m aware of strategies for negotiating the power I need in order to be effective in any situation.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("33. I understand the theories and primary methodologies of Organization Development.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("34. I’m aware of the steps that make up the core processes that facilitators are asked to apply.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("35. I’m aware of change management models and can use them to design and implement complex change activities.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("36. I know how to design and facilitate various strategic and business planning discussions.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("37. I know the steps in the main process tools that are part of process improvement efforts, such as process mapping.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("38. I’m skilled at designing and implementing surveys.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("39. I’m skilled at using survey feedback to involve clients to interpret their own data and identify actions.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("40. I’m able to design and implement interpersonal and intergroup conflict interventions to settle contentious issues.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("41. I’m aware of the steps in the coaching process and know how to use coaching to help individuals and teams.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("42. I’m able to deal comfortably with high-level management one-on-one and in group settings.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("43. I know how to contract for the use of my services as a neutral third party and operate as a process consultant.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("44. I’m able to design complex one- and two-day meetings and retreats to achieve specific outcomes")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("____")])])])]), _vm._v(" "), _c('div', {
    staticClass: "feature3"
  }, [_c('div', {
    staticClass: "feature3_text"
  }, [_vm._v("Level III skills I currently possess:")]), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "feature3_text"
  }, [_vm._v("Level III skills that I would like to develop further:")]), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Combine the areas of further learning that you have identified in each of the three levels to create a personal learning plan to guide you.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The skills and competencies that I plan to acquire or improve include:")]), _vm._v(" "), _c('div', {
    staticClass: "graphic"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0012-02.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "sec04"
    }
  }), _vm._v("The Power of Your Presence")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("In addition to possessing advanced tools and techniques, facilitators need to be conscious of the behaviors they exhibit and the image that they project. We have probably all known skilled facilitators whose performance was undermined because they unconsciously projected a negative attitude. To a great extent every facilitator’s ability to be effective depends on how they’re perceived.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When we stand in front of a group, all eyes are on us. As we work with them, people form an opinion about us. They decide if we’re up to the task, if they can trust us, if they think we’re sincere.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When a facilitator is an effective instrument for positive interaction, he or she projects a calm, confident demeanor. Their body posture is erect, without being stiff. They make appropriate hand and body motions that enhance or clarify what they’re saying.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Skilled facilitators make ongoing eye contact with group members that’s both comfortable and welcoming. By being candid and open they communicate that they are authentic in their interest in serving the group.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Accomplished process leaders show sensitivity by listening intently, noticing reactions and asking about feelings. They’re never oblivious to concerns, but listen actively and don’t hesitate to ask about feelings when it’s helpful to do so.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If the atmosphere becomes strained, advanced facilitators show self-control and are able to refrain from becoming overly emotional. They’re able to manage their own emotions, even in difficult situations. They never lose their temper, become embroiled in disputes, or show their displeasure.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Expert practitioners demonstrate their flexibility by constantly testing the process, offering options and adjusting activities. They pay attention to the proceedings and never get lost, forget key ideas, or allow themselves to become distracted.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Masterful facilitators are always unobtrusive, avoid the limelight and talk little, to ensure that member ideas dominate and so that the members feel a sense of ownership for the results of their deliberations.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Finally, advanced facilitators manage their personal energy so that the proceedings don’t lose momentum. They strive to stay energetic and appear totally engaged throughout.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Your first step toward understanding what you project is to rate yourself on the instrument that follows. You could also ask a colleague to observe you in action and then offer specific feedback about how others see you.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "lev01"
    }
  }), _vm._v("Personal Projection Assessment")]), _vm._v(" "), _c('div', {
    staticClass: "graphic"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "graphic"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0015-01.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "sec05"
    }
  }), _vm._v("What is O.D.?")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("Organization Development is a planned effort to increase organization effectiveness and health through planned interventions in the organization’s processes using behavioral science knowledge. It was created in 1949 as a fusion of behavioral science and management theory. O.D. uses fundamental group processes to harness the wisdom and commitment of stakeholders to improve their own organizations. It’s based on the belief that people are wise and will have more commitment to the plans or changes that they’ve designed for themselves.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("The Key Principles and Practices")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("The essential principles of O.D. are listed below. You will note that these are completely coherent with the core beliefs of facilitation. These key principles are:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("People are healthy, self-motivated and capable.")]), _vm._v(" "), _c('li', [_vm._v("People will support what they create.")]), _vm._v(" "), _c('li', [_vm._v("Personal values must be examined.")]), _vm._v(" "), _c('li', [_vm._v("Everyone must respect the values of others.")]), _vm._v(" "), _c('li', [_vm._v("Interpersonal relations are critically important.")]), _vm._v(" "), _c('li', [_vm._v("Leadership style is important.")]), _vm._v(" "), _c('li', [_vm._v("Organization dynamics are important.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("O.D. is totally holistic: it takes a systems view that asserts that all systems are connected and interrelated; that people are interrelated; that you can’t change just one part of an organization. Organization Development is always viewed as an ongoing and continuous change effort whose overall aim is increased personal and organizational effectiveness.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("The Core O.D. Activities")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("Whenever a facilitator leads discussions that are part of any of the following activities, he or she is in fact working as an O.D. practitioner:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("action research/diagnostic activities")]), _vm._v(" "), _c('li', [_vm._v("problem solving/process improvement")]), _vm._v(" "), _c('li', [_vm._v("strategy planning")]), _vm._v(" "), _c('li', [_vm._v("survey-feedback activities")]), _vm._v(" "), _c('li', [_vm._v("organizational restructuring, planning and goal setting")]), _vm._v(" "), _c('li', [_vm._v("techno-structural/work redesign activities")]), _vm._v(" "), _c('li', [_vm._v("managing change")]), _vm._v(" "), _c('li', [_vm._v("team building")]), _vm._v(" "), _c('li', [_vm._v("inter-group activities/negotiating")]), _vm._v(" "), _c('li', [_vm._v("leadership development")]), _vm._v(" "), _c('li', [_vm._v("coaching and counseling")]), _vm._v(" "), _c('li', [_vm._v("training linked to achieving change goals")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In some cases an entire intervention may take place in a single meeting. An example of this might be a one-time team-building retreat. In other cases the facilitated meeting may be part of an ongoing series of discussions spread over several months. An example of this might be a process-improvement project.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Whether a meeting fits within a short or long time frame, it needs to be planned as part of a systemic change process that impacts the broader organization.")]), _vm._v(" "), _c('div', {
    staticClass: "feature2"
  }, [_c('div', {
    staticClass: "feature2_text"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Aside from leading routine staff meetings all other facilitations are O.D. activities!")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To help you place your facilitation activities within this broader context of an O.D. intervention, this book provides the generic steps of O.D. processes in Chapter 5 and outlines the steps in the consulting process that are described in Chapter 4.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("Learn More About O.D.")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("Since most facilitation activities take place within the context of an O.D. intervention, it’s vitally important that all advanced practitioners become well read on this important topic. One of the most concise and easy to read handbooks on the subject is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Practicing Organization Development: A Guide for Consultants")]), _vm._v(" by Rothwell, Sullivan and McLean. (1995, Jossey-Bass). The chapter references for Chapter 1 (p. 283) suggest additional titles that advanced facilitators may wish to read.")]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "sec06"
    }
  }), _vm._v("Working as a Consultant")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("Throughout this book, the facilitator is often referred to as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("consultant")]), _vm._v(" while the participant is described as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("client.")]), _vm._v(" This is in keeping with this idea of facilitation as a contracted role that has no intrinsic power or control over the situation other than the power that’s been negotiated. Consider the definition of consulting provided by Peter Block in his seminal work "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Flawless Consulting:")])]), _vm._v(" "), _c('div', {
    staticClass: "feature2"
  }, [_c('div', {
    staticClass: "feature2_text"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("“You are consulting anytime you are trying to change or improve a situation but have no direct control over the implementation. If you had control you’d be managing.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In this context anytime you’re asked to design, plan and lead a facilitated discussion that’s part of a planned change effort and where you’re an external third party, you’re operating as a consultant.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "lev02"
    }
  }), _vm._v("Two Forms of Consulting")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("Before the field of O.D. was created, the dominant form of consulting was expert based. In this model the third party is brought in to assess a situation and offer their recommendations for action. O.D. created an alternative form of consulting in which the external third party does not offer advice, but provides the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("processes")]), _vm._v(" through which clients can create and implement their own plans.")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "98%"
    }
  }, [_c('thead', [_c('tr', [_c('td', {
    staticClass: "tabularhead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Expert consulting")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularhead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Process consultants")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("1. Preliminary diagnosis")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("1. Preliminary diagnosis")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("2. Data gathering")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("2. Data gathering")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("3. Analysis by expert")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("3. Data feedback to clients")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("4. Recommendations for action by consultant")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("4. Data analysis by clients")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("5. Action planning by clients")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("5. Implementation")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("6. Implementation by clients")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/triangle.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/triangle.jpg"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("The consultant offers content in the form of expert advice")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("The consultant offers processes and facilitates")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("The consultant is not neutral")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("The consultant is neutral")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("The consultant offers their expertise")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("The consultant brings process skills")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("The consultant prescribes")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("The consultant is nonprescriptive")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("The consultant may manages implementation activities")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("The consultant supports the client’s efforts")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Thinking of yourself as a consultant and managing your facilitation assignments using the steps of the consulting process that are outlined in Chapter 4 will not only help you manage your work, but will also generate a greater sense of professionalism. This is especially important if you are working as an internal facilitator.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("The Connection to Facilitation")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("Since O.D. consulting is the application of process while remaining neutral on the content, it’s easy to see that all facilitated discussions that aim to solve a problem, resolve a conflict, plan a strategy, or create change are essentially Organization Development activities. It is further also true that all O.D. practitioners are expert facilitators.")]), _vm._v(" "), _c('div', {
    staticClass: "feature2"
  }, [_c('div', {
    staticClass: "feature2_text"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Most facilitation assignments are O.D. activities.")])])]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "sec07"
    }
  }), _vm._v("Expanding Your Power Base")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("Those who are new to facilitation often operate under the mistaken assumption that being neutral about the content under discussion also means being neutral about the process. The result of this thinking is that many neophytes project such a sense of powerlessness that they end up as little more than scribes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This power dilemma is most acutely felt by internal facilitators. While external process leaders are assumed to be credible and automatically given more authority, internal facilitators tend to have much less clout. To complicate matters further, internal facilitators often lead meetings attended by their peers and the managers to whom they report. These factors combine to inhibit internal facilitators from acting authoritatively.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Whether you’re an internal or external facilitator, it’s important that you’re aware that facilitation is not a powerless role! While it’s true that facilitators are impartial about the outcome of discussions, it’s a mistake to extend this notion of neutrality to the process elements. The result of this mistaken thinking is that inexperienced facilitators often stand by mutely while participants ignore their agenda and interact dysfunctionally.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In contrast, experienced facilitators are much more assertive because they understand that neutrality refers only to the content elements. In addition to this they also know that:")]), _vm._v(" "), _c('div', {
    staticClass: "feature2"
  }, [_c('div', {
    staticClass: "feature2_text"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The amount of power a facilitator has in any situation = the amount of power that they negotiate!")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This suggests two strategies:")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "item1"
  }, [_vm._v("1. Facilitators should always manage the process elements assertively, plus")]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_vm._v("2. Facilitators should always seek the additional powers they will need in order to work effectively.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To illustrate this principle, here’s an example of a power negotiation between an internal facilitator and a group of senior executives:")]), _vm._v(" "), _c('div', {
    staticClass: "feature3"
  }, [_c('div', {
    staticClass: "feature3_text"
  }, [_vm._v("From your past experience with this specific group of upper managers, you know that they tend to grandstand, interrupt each other and ignore the process steps that they agreed to follow. In the past you’ve felt powerless to make interventions because you’re in a relatively junior position and are concerned about offending senior leaders. Since you don’t want to preside over a disastrous meeting, you start the session by engaging the group in a conversation about your role, saying something like:")]), _vm._v(" "), _c('div', {
    staticClass: "featureextract"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I want this to be a productive and worthwhile meeting for you. In order for me to do my job well today, I need to clarify some things with you.")])]), _vm._v(" "), _c('div', {
    staticClass: "featureextract"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("If I sense that people aren’t hearing each other’s points, for example, I want to make sure it’s okay for me to stop the conversation and get the parties to repeat each other’s key ideas to make sure all ideas are heard.")])]), _vm._v(" "), _c('div', {
    staticClass: "featureextract"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I also want to make sure that it’s okay for me to stop any debates that get heated and ask people to restate their points in language that’s more neutral.")])]), _vm._v(" "), _c('div', {
    staticClass: "featureextract"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Finally, I want to ensure that it’s seen as my role to point out when time limits are being ignored so we can get back on track.")])]), _vm._v(" "), _c('div', {
    staticClass: "featureextract"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Are there any other situations that could come up at today’s meetings and what is it okay for me to say or do in each situation?")])]), _vm._v(" "), _c('div', {
    staticClass: "feature3_text"
  }, [_vm._v("As group members respond to your questions, they’ll be basically ratifying your power to control the process. Make notes on a sheet of flip chart paper, taking special care to use any specific wording suggested by the members. Then post the list of your new powers in clear sight.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("You may have recognized that this is a form of norming, known as a normative contract. In this example the normative contract is aimed at increasing personal leverage. Once you’ve completed these negotiations, the stage will be set for you to manage as assertively as necessary. Rather than being offended by your interventions, participants will feel that you’re doing their bidding.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("Why Negotiate Power You Already Possess?")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("It’s important to note that you don’t actually need the permission of participants to assertively manage things like behavior, since facilitators already have the right to manage the process elements. But we all know that theoretical power isn’t necessarily power you can wield. The negotiation process is simply used in these cases to gain buy-in for your ability to exercise your role to its fullest extent.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In addition to affirming your power to assertively manage the process elements during discussions, facilitators can also negotiate other conditions surrounding their work. These negotiations will not only reduce confusion group members may have about your role, but will also allow you to have a say in the design of any interventions that you may need to make.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Some of the normative contracts that a facilitator might seek include:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("that key decision makers will be present")]), _vm._v(" "), _c('li', [_vm._v("that you will be granted full access to staff in order to gather background information from participants")]), _vm._v(" "), _c('li', [_vm._v("that group members will respect your process design and agree to adhere to it throughout the proceedings")]), _vm._v(" "), _c('li', [_vm._v("that the important elements of organizational support are in place before an activity proceeds")]), _vm._v(" "), _c('li', [_vm._v("that you will be given a role in managing the follow-up process")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The notion of negotiating in order to gain additional power is described in more detail starting in Chapter 4 in the section on contracting for your services. It is also illustrated on page 98 in Chapter 3.")]), _vm._v(" "), _c('div', {
    staticClass: "feature3"
  }, [_c('div', {
    staticClass: "feature3_text"
  }, [_vm._v("To help you identify opportunities to negotiate more power, identify the scenarios and situations in which you feel powerless as a facilitator. Next, identify the specific powers that you need in each of these situations:")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "98%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("When do I feel powerless?")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-01.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("What powers do I need in these situations?")])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "lev03"
    }
  }), _vm._v("Gaining the Authority to Facilitate")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("New facilitators are often unsure about just how much authority they possess when they’re acting as a facilitator. This is especially true for people working inside organizations who haven’t officially been given the title of facilitator. These folks wonder whether they have the authority to lead a group discussion and too often hold back their process expertise out of fear that they’ll appear to be challenging the power of the group’s official leader.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This concern is based on the assumption that facilitation is like other jobs that depend on having some form of official designation. It’s also rooted in the fact that facilitation is essentially a powerless role with no inherent authority.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Advanced practitioners aren’t bothered by this power vacuum. They know that they can obtain the right to facilitate in any situation. While it certainly helps to have a manager’s approval or be officially assigned to be the facilitator for a specific group, a formal job description isn’t needed to step into the role. What is needed is the consent of the people being facilitated.")]), _vm._v(" "), _c('div', {
    staticClass: "feature2"
  }, [_c('div', {
    staticClass: "feature2_text"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Never forget that facilitation is leadership by consent!")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This consent can be gained in two ways: through formal negotiations during the contracting phase of any facilitation assignment or by simply offering to act as facilitator and having the group members accept. Once a group has agreed to be facilitated, that agreement is a form of contract whether it’s a verbal contract for a single meeting or a detailed letter of agreement to facilitate a lengthy project.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If lack of official approval remains a major stumbling block to getting your expertise used, make facilitation skills a priority in your personal learning plan and ask your manager for opportunities to practice. More organizations are also creating volunteer cadres of internal facilitators that you may be able to join.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In summary, remember that:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("facilitation doesn’t come with any inherent power beyond what’s negotiated with group members;")]), _vm._v(" "), _c('li', [_vm._v("any official power of the person facilitating is outside the facilitation role;")]), _vm._v(" "), _c('li', [_vm._v("the role of facilitator doesn’t need to be an officially designated role and has nothing to do with rank; and")]), _vm._v(" "), _c('li', [_vm._v("in order to facilitate you need only gain the consent of the participants.")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "lev04"
    }
  }), _vm._v("Losing the Facilitator Role")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("Since facilitation power is relatively easy to gain, it’s important to be aware that there’s a flip side to that coin: namely, that it’s equally easy to fall out of the role!")]), _vm._v(" "), _c('div', {
    staticClass: "feature2"
  }, [_c('div', {
    staticClass: "feature2_text"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gaining the role is the easy part . . . . . . keeping it is much harder!")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A facilitator can lose the role for a whole host of reasons:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("The process being used is based on insufficient information, the wrong information, or assumptions that were never tested.")]), _vm._v(" "), _c('li', [_vm._v("The design was created without being tested with the participants to gain their buy-in.")]), _vm._v(" "), _c('li', [_vm._v("The skills and experience of the facilitator do not match the difficulty level of the conversation.")]), _vm._v(" "), _c('li', [_vm._v("The facilitator failed to engage the group in setting the needed norms for the situation.")]), _vm._v(" "), _c('li', [_vm._v("The facilitator failed to be appropriately assertive in managing the process.")]), _vm._v(" "), _c('li', [_vm._v("The facilitator engages in unintentional behaviors that resulted in a loss of neutrality.")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("Unintentionally Losing Neutrality")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("One of the most common ways that facilitators lose the role is by unintentionally losing their neutrality concerning the content. This can happen in a number of ways:")]), _vm._v(" "), _c('p', {
    staticClass: "extractpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Changing members’ words")]), _vm._v(" – recording ideas that don’t reflect what people are actually saying. Putting in words that you like better without ratifying them with the members. Rewriting reports to more closely reflect your views or the views of management.")]), _vm._v(" "), _c('p', {
    staticClass: "extractpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Taking sides")]), _vm._v(" – saying things like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("good idea")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("good point")]), _vm._v(" when someone makes a comment you like without realizing that another member who has an opposing opinion now sees you as having taken sides.")]), _vm._v(" "), _c('p', {
    staticClass: "extractpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Asking too many leading questions")]), _vm._v(" – or asking overly critical questions may undermine member confidence in their own opinions and steer them toward decisions for which they have no real commitment.")]), _vm._v(" "), _c('p', {
    staticClass: "extractpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Unconscious selling")]), _vm._v(" – repeatedly making suggestions that may have been rejected by the group earlier. Offering suggestions in a way that doesn’t feel neutral to members.")]), _vm._v(" "), _c('p', {
    staticClass: "extractpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Not checking assumptions")]), _vm._v(" – moving forward without checking personal assumptions. Operating out of mistaken beliefs or with incomplete information. Operating out of one’s own prejudices.")]), _vm._v(" "), _c('p', {
    staticClass: "extractpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Answering content questions")]), _vm._v(" – instead of redirecting these questions to other group members or making a process response. Voicing opinions and joining into decision-making discussions.")]), _vm._v(" "), _c('p', {
    staticClass: "extractpara"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Favoring one person or party over another")]), _vm._v(" – giving one person or party more time to present their ideas. Making eye contact with some people and not with others. Unintentionally encouraging one person or party more than another.")]), _vm._v(" "), _c('div', {
    staticClass: "feature3"
  }, [_c('div', {
    staticClass: "feature3_text"
  }, [_vm._v("Raise your personal awareness of this important issue by reflecting on your past experience:")]), _vm._v(" "), _c('div', {
    staticClass: "feature3_text"
  }, [_vm._v("Have you ever lost the facilitator role in the middle of a meeting?")]), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "feature3_text"
  }, [_vm._v("Which of the factors mentioned earlier contributed to your losing the role?")]), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "lev05"
    }
  }), _vm._v("Maintaining and Regaining the Role")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("Since process leadership can easily be lost, it’s important to have strategies to regain followership whenever it happens. The first step, of course, is to attune yourself to the signs that this has happened. Pay attention to body language signals that announce people are annoyed, frustrated, or have simply tuned out.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Since people are unlikely to speak up and announce that they’ve lost faith in either you or the proceedings, take a proactive approach by making periodic process checks. This involves stopping the action from time to time to ask:")]), _vm._v(" "), _c('p', {
    staticClass: "extractpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Is this working? Are we on track? Are we making progress?")])]), _vm._v(" "), _c('p', {
    staticClass: "extractpara"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Is the tool we’re using effective or should we try another technique?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Even when a facilitator asks for feedback, participants may be reluctant to speak out. In these situations try posting a midpoint check that allows people to make written, anonymous responses. When you invite participants to complete the survey, encourage them to be candid and assure them that their honest views are wanted. This activity is also illustrated on page 144 in Chapter 3.")]), _vm._v(" "), _c('div', {
    staticClass: "graphic"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Once the survey has been completed, review the results with the members and ask:")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "item1"
  }, [_vm._v("1) Why did each question receive the rating that it got?")]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_vm._v("2) What can be done during the rest of the meeting to improve the ratings for each item?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Implement all of the ideas that are feasible and likely to help improve session effectiveness.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Midpoint checks are an important tool to add to your tool kit and an indispensable strategy for testing the quality of your work while there’s still time to resolve problems. It should be a part of your design for all lengthy meetings. A further illustration of this strategy in action can be found on page 150 in the section on conflict management strategies.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("Inviting Personal Feedback")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("If you sense that meeting problems stem from your process leadership, you could include a question that invites personal feedback, such as the one below:")]), _vm._v(" "), _c('div', {
    staticClass: "graphic"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0026-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If you sense that people might be reluctant to respond to a survey question about your performance, absent yourself from the room while one of the group members leads a short discussion that centers on the two questions above.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If the notion of asking for personal feedback seems too risky, weigh those risks against the danger of carrying on with a facilitation that feels like it isn’t working. Carrying on like nothing’s wrong, when there is a problem, sends the message that you can’t read the group or deal confidently with conflict.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Creating a safe vehicle for group members to surface and help deal with a sensitive feedback situation sends the message that you are confident, can hear constructive feedback, and are capable of managing a challenging situation. This isn’t an easy thing to do, but it is the strategy an advanced facilitator would apply!")]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "sec08"
    }
  }), _vm._v("The Two Types of Interventions")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("When a discussion encounters difficulty, it’s the facilitator’s job to make an intervention. Too often novice facilitators hesitate to take action because they worry that they lack the power to intervene or that they’ll offend someone in the group.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Experienced facilitators know that making interventions is totally within the boundaries of the facilitator’s role, does not violate their neutrality, and must be made whenever an ineffective situation threatens group effectiveness. Some examples of situations that require intervening include:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("a group making a hasty decision without sufficient data")]), _vm._v(" "), _c('li', [_vm._v("a group that throws out its process")]), _vm._v(" "), _c('li', [_vm._v("when the solution being proposed lacks the creativity or innovation required by the situation")]), _vm._v(" "), _c('li', [_vm._v("when group members fail to explore a wide range of possibilities because an influential member is pressuring them to accept the solutions they favor")]), _vm._v(" "), _c('li', [_vm._v("whenever member behaviors become ineffective and hamper progress.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Advanced facilitators are also aware that intervention responses fall into two categories, and they know when to use each type:")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "98%"
    }
  }, [_c('thead', [_c('tr', [_c('td', {
    staticClass: "tabularhead",
    staticStyle: {
      "width": "48%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Content interventions")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularhead",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Process interventions")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Offering expertise")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Providing feedback")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Making suggestions")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Offering critiquing tools")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Giving advice")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Redirecting behaviors")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Telling members what to do")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Asking probing questions")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("When to Make Content Interventions")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("By definition, facilitation is a neutral process role. However, facilitators are often working in areas where they’re experts. When this is the case and when the group is in need of additional information or expert advice, a content intervention may indeed be appropriate.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Stepping out of the neutral role to participate in the content is tricky since it may shift power away from group members toward the facilitator so that he or she ends up controlling the outcome.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To guard against this possibility, content interventions need to be made cautiously and intentionally. Here are some guidelines that may be helpful:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Identify your specific expertise early in the planning stages and agree on when and how that expertise will be shared.")]), _vm._v(" "), _c('li', [_vm._v("Describe personal areas of expertise to participants at the start of any meeting where you might play both roles.")]), _vm._v(" "), _c('li', [_vm._v("Design the agenda so that expertise-sharing sessions are clearly segregated from group discussions.")]), _vm._v(" "), _c('li', [_vm._v("If there’s an unexpected need for your expertise in the middle of a discussion, clearly state the you’re stepping out of the facilitator role to offer expert advice.")]), _vm._v(" "), _c('li', [_vm._v("Always be clear whether you’re sharing expert opinion or non-negotiable input:")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "98%"
    }
  }, [_c('thead', [_c('tr', [_c('td', {
    staticClass: "tabularhead",
    staticStyle: {
      "width": "48%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Expert opinion is:")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularhead",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Nonnegotiable input is:")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Explaining a preference based on your expertise Open to change")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Something that’s legislated or is a design feature that’s not negotiable")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Based on my experience, I would choose . . . ”")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Here are the things that can’t be changed or omitted . . . ”")])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "lev06"
    }
  }), _vm._v("Deepening Your Process Responses")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("One of the greatest challenges reported by new facilitators is remaining neutral when a meeting starts to flounder. These situations can precipitate an unintentional slip out of the neutral role to critique responses and even prescribe solutions.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Since facilitation is a helping role, the impulse to rescue a struggling group is only natural. Couple this with the fact that facilitators should never stand by idly while a group makes a disastrous decision, and it’s easy to understand how readily neutrality can be violated.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("While there are instances, such as those described earlier, where it’s appropriate to step out of the neutral role to intervene in content, advanced practitioners possess a broad range of process interventions that preserve their neutral role.")]), _vm._v(" "), _c('div', {
    staticClass: "feature2"
  }, [_c('div', {
    staticClass: "feature2_text"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Aside from situations where content is intentionally shared, advanced facilitators always intervene on the process level.")])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("Examples of Process Interventions")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "98%"
    }
  }, [_c('thead', [_c('tr', [_c('td', {
    staticClass: "tabularhead",
    staticStyle: {
      "width": "48%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Situation")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularhead",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Process Intervention")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("The group makes a hasty decision without adequate data")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Engage members in identifying the data that’s needed to make an effective decision, then use this as a checklist to test the quality of the available options.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Members are taking positions and arguing emotionally to convince others they’re right")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Engage members in identifying the pros and cons of each proposal.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("A questionable course of action is identified")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Facilitate a discussion to name the key criteria for judging the quality of a solution. Assign weights to each criteria. Create a decision grid and test the course of action against each individual criteria element.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Members are stuck in old patterns and can’t think "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("out-of-the-box")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Help members describe the traits of an innovative solution. Then ask people to put on other "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hats")]), _vm._v(" to identify creative solutions.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Members can’t generate ideas")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Identify the key questions that need to be asked. Organize members to find stakeholders to interview or best practice organizations to research. Bring back input to spark idea generation.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("A course of action goes untested in a group with a track record for poor follow-through")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Engage the members in a troubleshooting discussion to identify all of the things that could go wrong or could block progress. Ask members to identify how they contribute to these blocks and barriers, then help members identify a strategy or make a commitment to respond to each block or barrier.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Members are failing to think critically about the situation.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Ask a series of probing questions that make people think more deeply about the current situation and/or the impact of various courses of actions.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Member behaviors deteriorate and adversely affect group effectiveness.")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Offer feedback about what you are noticing, then engage members in setting new norms aimed at getting members to act appropriately.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Identify the types of situations where you often find yourself slipping out of the neutral role to make unintended content interventions. Then identify some of the process responses you will use in future occurrences:")]), _vm._v(" "), _c('div', {
    staticClass: "graphic"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0030-01.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "sec09"
    }
  }), _vm._v("Managing the Role of Leaders")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("In order for any facilitated activity to be effective, the leader and the facilitator need to be crystal clear about each other’s respective roles and responsibilities. There are a number of dynamics that make it a challenge to balance the roles of the leader and facilitator:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Facilitators are usually asked to work with groups at the request of the leader. As a result, leaders often mistakenly assume that they’re the client and that the facilitator is there to do their bidding.")]), _vm._v(" "), _c('li', [_vm._v("Leaders often request facilitation assistance but actually have an outcome in mind that they want the facilitator to lead the group toward.")]), _vm._v(" "), _c('li', [_vm._v("Leaders may indicate that they’re prepared to give over process control, only to step in and try to control the flow, especially if the conversation shifts in a direction they don’t personally favor.")]), _vm._v(" "), _c('li', [_vm._v("Leaders may indicate a readiness to empower and share control that they aren’t actually prepared to accept.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Facilitators need strategies to deal with these scenarios:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Facilitators need to clarify that the client is always the entire group, department, or team, including the leader, but is not exclusively the leader. This should be done verbally and reinforced in writing in advance of any assignment. All group members should be made aware that they, not just the leader, are the client of the facilitator.")]), _vm._v(" "), _c('li', [_vm._v("The facilitator needs to ask the leader if they have a specific outcome in mind, how open they are to innovative solutions, or if there are specific solutions that need to be classified as unacceptable.")]), _vm._v(" "), _c('li', [_vm._v("The facilitator needs to clarify his or her role in advance of the meeting so that both the leader and the other participants are clear that it’s the facilitator’s role to design and manage all process elements.")]), _vm._v(" "), _c('li', [_vm._v("The facilitator needs to share the four-stage empowerment chart with the leader to identify the level at which each conversation will be taking place:")])]), _vm._v(" "), _c('div', {
    staticClass: "item2"
  }, [_c('p', {
    staticClass: "listpara2"
  }, [_vm._v("Level I – the group being told an outcome")]), _vm._v(" "), _c('p', {
    staticClass: "listpara2"
  }, [_vm._v("Level II – members being asked for their input to a decision to be made elsewhere later")]), _vm._v(" "), _c('p', {
    staticClass: "listpara2"
  }, [_vm._v("Level III – members being asked to make recommendations that require further management approval, or")]), _vm._v(" "), _c('p', {
    staticClass: "listpara2"
  }, [_vm._v("Level IV – members totally empowered to make an independent decision and take action without further approvals.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The strategy of clarifying empowerment levels is illustrated in greater detail on page 53 in Chapter 2 where strategies to clarify empowerment are provided.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "lev07"
    }
  }), _vm._v("When The Boss Is in the Room")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("In an ideal world, relations between leaders and staff would be so safe, open, and honest that everyone could confidently speak their mind with managers present. The sad truth is that most groups feel very inhibited in the presence of leaders.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sometimes this is due to a past history of reprisals over comments made at meetings. In other cases the unease stems from a simple lack of experience with collaboration and dialogue between organizational levels. Whether this inhibition is real or just a perception, facilitators need strategies to ensure that conversations aren’t hampered by the presence of leaders.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("First, let’s look at the pros and cons of having leaders present during facilitated conversations:")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "98%"
    }
  }, [_c('thead', [_c('tr', [_c('td', {
    staticClass: "tabularhead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pros")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularhead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cons")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_c('ul', [_c('li', [_vm._v("their presence demonstrates their openness and commitment to collaboration")]), _vm._v(" "), _c('li', [_vm._v("leaders have wisdom and expertise to add")]), _vm._v(" "), _c('li', [_vm._v("they see the big picture")]), _vm._v(" "), _c('li', [_vm._v("they can help the group access resources and remove barriers")])])]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('ul', [_c('li', [_vm._v("the leader’s presence may keep people from raising issues or identifying problems")]), _vm._v(" "), _c('li', [_vm._v("their presence may inhibit discussion and creativity")]), _vm._v(" "), _c('li', [_vm._v("the leader may dominate")]), _vm._v(" "), _c('li', [_vm._v("they may hinder member ownership")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Asking leaders not to attend meetings is not only impractical, but also denies the group one of its most valuable resources. The key is to talk to leaders in advance about the potential downside of their participation to increase their awareness and enroll their support.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Here are some strategies to consider:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Ask the leader to start meetings where staff input is being sought by making a statement that sets a positive and open tone. He or she could ask for lively debate and a free exchange of creative ideas.")]), _vm._v(" "), _c('li', [_vm._v("The leader could be invited to suggest some "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("safety norms")]), _vm._v(" for the session such as:")])]), _vm._v(" "), _c('div', {
    staticClass: "item2"
  }, [_c('p', {
    staticClass: "listpara2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What’s said in the room, stays in the room.")])]), _vm._v(" "), _c('p', {
    staticClass: "listpara2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Naming issues or problems in order to solve them is constructive.")])]), _vm._v(" "), _c('p', {
    staticClass: "listpara2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("There will be no retaliation for any comments made in a problem-solving spirit.")])])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Reduce leader domination by coaching them to refrain from putting their ideas or solutions on the table too early or too often so they don’t hinder input.")]), _vm._v(" "), _c('li', [_vm._v("Ask leaders to clearly announce when they’re sharing expertise, offering information, or announcing a nonnegotiable item. Help them to see this as different from offering an idea or suggestion.")]), _vm._v(" "), _c('li', [_vm._v("Coach leaders to present their ideas as questions instead of statements, so as to encourage conversations rather than end them.")]), _vm._v(" "), _c('li', [_vm._v("Encourage the leader to switch from strictly playing the content role to taking up more facilitative functions like paraphrasing the comments of others, asking clarifying questions, posing probing questions, and asking quiet people for their input.")]), _vm._v(" "), _c('li', [_vm._v("The facilitation design should include a variety of discussion techniques that provide private avenues for sharing ideas. These include techniques like dyads, small groups, written brainstorming, multivoting and wandering flip charts.")]), _vm._v(" "), _c('li', [_vm._v("The meeting design could be divided into sections so that the leader can share valuable information, then leave during sensitive problem solving discussion. He or she can then return to hear recommendations for action and to offer their support.")]), _vm._v(" "), _c('li', [_vm._v("Finally, the leader should be encouraged to refrain from taking responsibility for action plans that are more suitably left to staff. Encourage the leader to play the role of champion to staff initiatives, which involves coaching, obtaining resources and removing barriers.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Above all, managing the participation of leaders shouldn’t be left until the middle of the session when negative impacts of their presence have already had an effect on proceedings.")]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "sec10"
    }
  }), _vm._v("Enhancing Your Questioning Skills")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("Since facilitation is essentially a questioning function, it’s not an exaggeration to say that a facilitator is only as good as the questions they ask! Asking a weak question may send a group in the wrong direction. Failing to ask the right probing questions may result in the group not exploring issues deeply enough. For this reason advanced facilitators must be extremely skilled at asking the right question at the right time.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Before launching into any line of questioning, always asks yourself:")]), _vm._v(" "), _c('div', {
    staticClass: "feature2"
  }, [_c('ul', [_c('li', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What do I want to ask?")])]), _vm._v(" "), _c('li', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Why do I want to ask this?")])]), _vm._v(" "), _c('li', [_c('em', {
    staticClass: "italic"
  }, [_vm._v("How might people respond?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Regardless of the question type (open or closed) or the setting, here are some question development guidelines to consider:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Always customize the questions to fit the context.")]), _vm._v(" "), _c('li', [_vm._v("Ask questions that people are capable of answering.")]), _vm._v(" "), _c('li', [_vm._v("Use language that’s clear and unambiguous.")]), _vm._v(" "), _c('li', [_vm._v("Create safety before asking difficult questions.")]), _vm._v(" "), _c('li', [_vm._v("Stay open and avoid questions that lead people to specific conclusions.")]), _vm._v(" "), _c('li', [_vm._v("Ask follow-on questions that fit with the flow of the conversation.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Questions fall into a number of categories depending on what they’re intended to do. In addition to the examples offered here, you will find dozens of examples of questions scattered throughout this book. Here are a few of the main categories of questions in common use:")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "98%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Questions that set the context")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What’s our goal at this meeting?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What are your expected outcomes?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Questions that invite development")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Can you say more?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What else is connected to this?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Questions that probe")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("How did this start?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s involved?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What’s the history of this?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Questions that clarify")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Are you saying . . . ?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Am I understanding that . . . ?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Questions that diverge")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What would be the opposite of that?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What would the competition do?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Questions that reframe")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Can you say that in another way?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Questions that link")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What else fits here?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What comes to mind that is similar?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("When did this happen before?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Questions that invite challenge")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Who sees it a different way?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What would our competitors say?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Questions that test")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What are the pros and cons of this?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What are the main blocks and barriers?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Questions that summarize")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What are the key ideas we can all live with?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What can we say to bring closure?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Questions that build buy-in")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What’s in it for you?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What do you stand to gain?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Questions that overcome resistance")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What concerns you about this topic?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What conditions or assurances will overcome those concerns?")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This large and complex topic deserves far more attention than can be provided given the scope of this book. For a resource devoted entirely to questioning take a look at "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Questions That Work")]), _vm._v(" by Dorothy Strachen (ST Press, 2001) for a comprehensive overview of this essential art. There is also an excellent overview of questioning in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Secrets of Facilitation")]), _vm._v(" by Michael Wilkinson (Jossey-Bass, 2004).")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "lev08"
    }
  }), _vm._v("Asking Complex, High-Quality Questions")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("While novice facilitators are often overreliant on asking "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("why")]), _vm._v(" or presenting simple questions, advanced facilitators tend to ask complex, high-quality questions that help the participants form a visual image of their response.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Here’s an example of these two types of questions:")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "98%"
    }
  }, [_c('thead', [_c('tr', [_c('td', {
    staticClass: "tabularhead",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Low-quality, simple questions")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularhead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("High-quality, complex questions")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What factors do we need to consider when ordering this year’s camp supplies?")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/sym.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("If we were going to provide every staff and member with exactly the right equipment to run exciting programs this year, what would each of them need?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What are the steps in the order-scheduling process?")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/sym.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Think about all of the steps that it takes to get an order to our customers. What’s the first step in that journey?")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What are the factors that contributed to the problems at this year’s festival?")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/sym.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Think back to this year’s festival and describe some of the glitches and frustrations that you experienced.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What would improve this plant?")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/sym.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Imagine that this plant is totally perfect! All the supplies and equipment are in place! All the systems are working! Describe what you see.")])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_vm._v("The Traits of Complex, High-Quality Questions")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("While there’s nothing inherently wrong with simple straightforward questions like the ones in the left-hand column above, the questions in the right-hand column are more likely to evoke thoughtful response. The reasons for this are related to the structure of these comments:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("High-quality questions start with prompts like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Imagine that . . . Think back to")]), _vm._v(" . . . or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("What if . . .")]), _vm._v(" that encourage participants to develop a clear picture of the scenario under discussion.")]), _vm._v(" "), _c('li', [_vm._v("High-quality questions are more personal and put the participant into the picture by using words like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you.")])]), _vm._v(" "), _c('li', [_vm._v("High-quality questions are less vague because they offer more details about the situation that’s being explored.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Advanced facilitators also incorporate comments from group members to create a connected line of questioning. This makes the questioning sequence more organized and links it to the participants.")]), _vm._v(" "), _c('div', {
    staticClass: "graphic"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0037-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As you move to a more advanced level of personal competence, you become more conscious of your questioning patterns:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Are you asking complex, high-quality questions that paint a picture and engage participants?")]), _vm._v(" "), _c('li', [_vm._v("Are your questions sufficiently detailed to avoid confusion about what you’re asking?")]), _vm._v(" "), _c('li', [_vm._v("Do you build on people’s comments to create a connected line of questioning?")]), _vm._v(" "), _c('li', [_vm._v("Are you conscious of the purpose of each question: are you asking to invite, probe, clarify, reframe, diverge, test, challenge, or link?")])]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "sec11"
    }
  }), _vm._v("Advanced Facilitation in Action")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("An important part of advancing to a higher skill level is incorporating specific techniques and behaviors into your work in front of groups. Since facilitation is such a highly personalized activity, it’s not possible to dictate how or when to incorporate these various techniques into your personal practice.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Instead, think of the following as descriptions of some of the things that advanced facilitators say and do that distinguish them from beginners.")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "item1"
  }, [_vm._v("1. Advanced facilitators always clarify the purpose, process, and expected outcomes at the start of all discussions to ensure that there’s a clear, shared focus.")]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_vm._v("2. They use norming in a very targeted way to set the climate, create safety, negotiate additional power, or enroll members to manage their own behavior.")]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_vm._v("3. Experienced facilitators confidently test their assumptions and check for buy-in from participants.")]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_vm._v("4. They paraphrase continuously to check for clarity and ensure that people feel heard.")]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_vm._v("5. Advanced facilitators ask complex, high-quality questions rather than relying on simple questions like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Why?")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("What else?")])]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_vm._v("6. Instead of keeping the process silent and hidden from participants, master facilitators verbalize it continuously so that participants know what they’re doing and why.")]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_vm._v("7. Instead of recording the ideas of individuals, skilled facilitators "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ping-pong")]), _vm._v(" comments around the group to create synergistic, multidirectional conversations.")]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_vm._v("8. Instead of wondering how things are going, master facilitators make frequent checks to test the purpose, the people, the process, and the pace.")]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_vm._v("9. Instead of tolerating dysfunctional behavior, advanced facilitators make appropriate interventions calmly and without hesitation.")]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_vm._v("10. They’re excellent at making clear notes and offering accurate summaries at the appropriate time in discussions.")]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_vm._v("11. Expert facilitators know how to help groups achieve closure in decision-making discussions, as well as help groups test the quality of their decisions.")]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_vm._v("12. They ensure that detailed action plans are in place and that blocks to implementation have been considered.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To further assist you in adding these elements to your repertoire, each practice is described in more detail on the pages that follow and are summarized on the observation sheet on page 39. This observation sheet can be used as a personal checklist or as a coaching tool.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "lev09"
    }
  }), _vm._v("Advanced Skills Observation Sheet")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "98%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tabularentry",
    staticStyle: {
      "width": "78%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Behaviors")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Clarifies the purpose and expected outcomes")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Clearly explains the process")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Is open to negotiating the purpose and process")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Makes sure the appropriate norms are in place")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("States/checks assumptions")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Tests for resistance and buy-in")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Paraphrases continuously")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Asks complex, high-quality questions")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Continuously verbalizes the process")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Ping-pongs conversation to create synergy")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Periodically checks the process")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Periodically reclarifies the purpose")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Periodically asks how people are doing")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Periodically asks about the pace")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Is energetic and maintains a good pace")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Assertively makes appropriate interventions")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Makes clear notes")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Offers accurate summaries")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Helps the group achieve closure")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Helps the group test the quality of outcomes")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_vm._v("Helps create clear and doable action plans")]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  })])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "lev10"
    }
  }), _vm._v("Debriefing Your Experience")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("No one becomes a master facilitator without experiencing their share of disasters! Don’t let those experiences deter you. The key is to glean valuable lessons from each one. After a particularly difficult facilitation, spend some time reflecting on what happened. Ask yourself:")]), _vm._v(" "), _c('p', {
    staticClass: "question"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/squ.gif"
    }
  }), _vm._v(" Did I do enough research about the client, their history, and culture? Did I really understand the group and its issues?")]), _vm._v(" "), _c('p', {
    staticClass: "question"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/squ.gif"
    }
  }), _vm._v(" Did I have a good sense of the personalities in the group – who might act out and their motives for doing so?")]), _vm._v(" "), _c('p', {
    staticClass: "question"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/squ.gif"
    }
  }), _vm._v(" Did I identify my assumptions about the group? Did I ever check them out, or did I hold on to them even when it became obvious that some of them were wrong?")]), _vm._v(" "), _c('p', {
    staticClass: "question"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/squ.gif"
    }
  }), _vm._v(" Did I prepare a detailed process outline for myself that included alternative approaches?")]), _vm._v(" "), _c('p', {
    staticClass: "question"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/squ.gif"
    }
  }), _vm._v(" Did I do a thorough job of clarifying the goal and the specific objectives of the meeting at the start, before jumping in?")]), _vm._v(" "), _c('p', {
    staticClass: "question"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/squ.gif"
    }
  }), _vm._v(" Did I explain my role and gain the authority and support I needed to run the meeting effectively?")]), _vm._v(" "), _c('p', {
    staticClass: "question"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/squ.gif"
    }
  }), _vm._v(" Did I review the norms with the group and ask targeted norming questions to head off difficulties that might arise?")]), _vm._v(" "), _c('p', {
    staticClass: "question"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/squ.gif"
    }
  }), _vm._v(" Did I get buy-in at the start of the meeting to make sure that people felt connected to the session?")]), _vm._v(" "), _c('p', {
    staticClass: "question"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/squ.gif"
    }
  }), _vm._v(" Did I do periodic process checks even when things seemed to be going well? Did I, for example, ask if we were making progress? Ask if the pace felt right or if the approach seemed to be working?")]), _vm._v(" "), _c('p', {
    staticClass: "question"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/squ.gif"
    }
  }), _vm._v(" Was I appropriately assertive in dealing with dysfunctional or ineffective behaviors, or did I hang back and avoid taking action?")]), _vm._v(" "), _c('p', {
    staticClass: "question"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/squ.gif"
    }
  }), _vm._v(" Did I engage in self-defeating thoughts and negative self-talk during difficult moments?")]), _vm._v(" "), _c('p', {
    staticClass: "question"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/squ.gif"
    }
  }), _vm._v(" Did I conduct an exit survey to get feedback from participants about how they viewed the meeting?")]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "sec12"
    }
  }), _vm._v("The Five Rules of Facilitation")]), _vm._v(" "), _c('p', {
    staticClass: "paraaftertitle"
  }, [_vm._v("The strategies in this book acknowledge that facilitating is a complex and challenging activity in which things rarely go as planned. Consider the following axiom:")]), _vm._v(" "), _c('div', {
    staticClass: "feature2"
  }, [_c('div', {
    staticClass: "feature2_text"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("While some facilitations are simpler than others, there are no simple facilitations.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This isn’t offered to set a negative tone, just to remind us all that whatever can go wrong, might just do that. It’s a reminder that anticipating and preparing to deal with challenging situations is far better than ignoring them and being surprised when they crop up.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To be better able to anticipate challenges, it’s important to understand the potential sources of complexity and the corresponding facilitation rules.")]), _vm._v(" "), _c('p', {
    staticClass: "paranumbered"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1. The Context:")]), _vm._v(" This is the organizational and cultural context that serves as the backdrop to the facilitation. This includes the history of the organization, its relative level of turbulence or stability, its current goals and strategies, its financial health, and its relationship with key stakeholders, plus various cultural elements such as dominant leadership style, the degree of empowerment given to employees, and trust levels.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Failure to do sufficient research into the context is a major source of facilitation failure. It leads to mistaken assumptions and hidden agendas that surface midstream to derail progress. A facilitation design that worked for one client will probably not work with any others. This rule reminds us that we must always do our homework to ensure that the work we do fits the situation and the needs of the client.")]), _vm._v(" "), _c('div', {
    staticClass: "feature2"
  }, [_c('div', {
    staticClass: "feature2_text"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Context, context, context.")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The First Rule of Facilitation")])]), _vm._v(" "), _c('p', {
    staticClass: "paranumbered"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2. The Purpose:")]), _vm._v(" This is the reason for the meeting. It refers to the overall purpose of the gathering, plus the expected outcomes associated with each individual agenda item. Failure to properly define the purpose and identify expected outcomes virtually guarantees a confusing meeting.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("No matter how clearly the content or task has been described and communicated, it’s simply astonishing how easily the focus of any discussion can change midstream. It’s equally astonishing that there always seem to be people in every meeting who are either confused about the purpose or who have a different view of the purpose. This rule reminds us that facilitators can’t clarify the purpose early enough or often enough to make sure everyone is still on the same page.")]), _vm._v(" "), _c('div', {
    staticClass: "feature2"
  }, [_c('div', {
    staticClass: "feature2_text"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Keep the purpose crystal clear.")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Second Rule of Facilitation")])]), _vm._v(" "), _c('p', {
    staticClass: "paranumbered"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3. The Process:")]), _vm._v(" This is the series of steps that will be used to achieve the meeting goal. It also refers to the specific tools and techniques that will be applied. The process can be designed only after the context has been examined and the purpose and the expected outcome have been identified.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Discussions that lack process or where the process is ignored inevitably turn into unstructured dialogues in which thoroughness and objectivity lose out to personal opinion and power plays. In many situations dysfunctional behavior is not the cause of ineffectiveness, as much as it is a symptom of poor process.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Even when a meeting is carefully planned, a myriad of factors can create the need for on-the-spot redesigning of key process elements. This rule reminds all facilitators that they must have a process in mind before setting out.")]), _vm._v(" "), _c('div', {
    staticClass: "feature2"
  }, [_c('div', {
    staticClass: "feature2_text"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Always create a detailed process agenda to guide your work.")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Third Rule of Facilitation")])]), _vm._v(" "), _c('p', {
    staticClass: "paranumbered"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4. The Behaviors:")]), _vm._v(" This is about how people interact, their intent, skills, and interaction style. It relates to whether or not the members exhibit effective task and maintenance behaviors during discussions.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("While there are individuals who are personally dysfunctional or who intentionally disrupt proceedings, a great deal of dysfunctional group behavior is actually the result of poor process. The other major contributing factor is a facilitator who stands by while things fall apart.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Too many facilitators interpret their neutrality about the topic under discussion to mean they should remain neutral about how people act. It’s both appropriate and necessary for all facilitators to make interventions to ensure that people’s behaviors remain effective at all times.")]), _vm._v(" "), _c('div', {
    staticClass: "feature2"
  }, [_c('div', {
    staticClass: "feature2_text"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Don’t hesitate to make needed interventions.")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Fourth Rule of Facilitation")])]), _vm._v(" "), _c('p', {
    staticClass: "paranumbered"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5. The Facilitator:")]), _vm._v(" This is about what we bring, what we project and how we act. It’s our body language, the words we choose, our style in front of the group and the attitude we convey. It’s about being a model for the collaborative spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("No matter how many tools and techniques you master, no one can be truly effective if they project negative images. Of these none is more detrimental than operating out of a sense of personal importance. Facilitators who use process work to make themselves look important or to exert their influence over outcomes are doing a disservice to the people they lead.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("All truly advanced facilitators are authentic, unobtrusive and sensitive. Their main goal is to help groups find their own voice and achieve outstanding results. They realize that tools and techniques are important, but that the most significant ingredient is often the positive presence of the facilitator.")]), _vm._v(" "), _c('div', {
    staticClass: "feature2"
  }, [_c('div', {
    staticClass: "feature2_text"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("You are the instrument!")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Fifth Rule of Facilitation")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "2",
      "cellspacing": "0",
      "width": "98%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tabularentry",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("While some facilitations are simpler than others, there are no simple facilitations.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The First Rule of Facilitation .................")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Context, context, context.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Second Rule of Facilitation .................")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Keep the purpose crystal clear.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Third Rule of Facilitation .................")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Always create a detailed process agenda to guide your work.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Fourth Rule of Facilitation .................")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Don’t hesitate to make needed interventions.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tabularentry"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Fifth Rule of Facilitation .................")])]), _vm._v(" "), _c('td', {
    staticClass: "tabularentry"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("You are the instrument!")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "feature3"
  }, [_c('div', {
    staticClass: "feature3_title"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "textbreak"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59400ec8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter01.vue
// module id = 69
// module chunks = 0